import { SortOrder } from '@studio/js-utils/sorting';
import type { Sorting } from './types.js';

/** Default sorting. */
export const DefaultSorting = { key: 'name', order: SortOrder.Ascending } satisfies Sorting;

/**
 * Grid layout for the discovery selector rows.
 *
 * Two independent toggles pick the variant:
 *   - showBrand (extended discovery): includes or omits the Brand column.
 *   - multi-select (bulk add): prepends a fixed 20px checkbox track.
 *
 * Column order (must stay aligned with header.tsx HEADER_FIELDS and
 * table.tsx `columns`): [checkbox?] name, ip, protocol, [brand?], bridge.
 * When the checkbox track is present the name/protocol pad anchors shift
 * one child to the right (nth-child(2)/(4) instead of first-child/(3)) so
 * the content indents match the no-checkbox variants.
 */
export const Layout = Object.freeze({
  // Brand shown, checkbox on — 6 columns: checkbox, name, ip, protocol, brand, bridge.
  row: 'grid grid-cols-[20px_minmax(120px,1.3fr)_minmax(95px,0.7fr)_minmax(75px,0.6fr)_minmax(105px,0.9fr)_minmax(75px,0.8fr)] [&>:nth-child(2)]:pl-12 [&>:nth-child(4)]:pl-20 text-sm items-center gap-12',
  // Brand shown, no checkbox — 5 columns: name, ip, protocol, brand, bridge.
  rowNoCheckbox:
    'grid grid-cols-[minmax(120px,1.3fr)_minmax(95px,0.7fr)_minmax(75px,0.6fr)_minmax(105px,0.9fr)_minmax(75px,0.8fr)] [&>:first-child]:pl-16 [&>:nth-child(3)]:pl-20 text-sm items-center gap-12',
  // Brand hidden, no checkbox — 4 columns: name, ip, protocol, bridge.
  rowNoBrand:
    'grid grid-cols-[minmax(120px,1.3fr)_minmax(95px,0.7fr)_minmax(75px,0.6fr)_minmax(75px,0.8fr)] [&>:first-child]:pl-16 [&>:nth-child(3)]:pl-20 text-sm items-center gap-12',
  // Brand shown, checkbox on — 6 columns: checkbox, name, ip, protocol, brand, bridge.
  rowWithCheckbox:
    'grid grid-cols-[20px_minmax(120px,1.3fr)_minmax(95px,0.7fr)_minmax(75px,0.6fr)_minmax(105px,0.9fr)_minmax(75px,0.8fr)] [&>:nth-child(2)]:pl-16 [&>:nth-child(4)]:pl-20 text-sm items-center gap-12',
  // Brand hidden, checkbox on — 5 columns: checkbox, name, ip, protocol, bridge.
  rowWithCheckboxNoBrand:
    'grid grid-cols-[20px_minmax(120px,1.3fr)_minmax(95px,0.7fr)_minmax(75px,0.6fr)_minmax(75px,0.8fr)] [&>:nth-child(2)]:pl-16 [&>:nth-child(4)]:pl-20 text-sm items-center gap-12'
});
